import { MdOutlineLooksOne, MdOutlineLooksTwo } from 'react-icons/md';
import { TmdxAvatar, cn } from '@ds';
import { OMSOnCallResource } from '@lp/features/Scheduler/SchedulerOMS';
import { getFullName } from '@/utils/helpers';

type OMSOnCallResourceCellItemProps = {
  isMe: boolean;
  resource: OMSOnCallResource;
};

export const OMSOnCallResourceCellItem = ({ resource, isMe }: OMSOnCallResourceCellItemProps) => {
  const fullName = getFullName(resource.firstName, resource.lastName);

  return (
    <div
      className={cn('flex items-center gap-1 h-5 px-0.75 rounded w-full', {
        'bg-[#0E9F6E33]': isMe && !resource.isVoluntary,
        'bg-[#0E9F6E73]': isMe && resource.isVoluntary,
      })}
    >
      <div className="flex items-center justify-center text-success-30">
        {resource.slotIndex === 1 && <MdOutlineLooksOne />}
        {resource.slotIndex === 2 && <MdOutlineLooksTwo />}
      </div>
      <div className="flex items-center gap-0.5 grow truncate">
        <TmdxAvatar size="sm" radius="sm" type="user" src={resource.profilePhoto} name={fullName} />
        <div className="text-s-m text-base-5 truncate">{fullName}</div>
      </div>
    </div>
  );
};
